<template>
  <zone-wrapper
    v-if="fields.scriptUrl?.value && bookSpaceAPISettings"
    :api-settings="bookSpaceAPISettings"
    :script-url="fields.scriptUrl.value"
    window-key="space-booking-settings-embed"
  >
    <div id="space-booking-widget-embed" class="book-space-widget">
      <div class="booking-app__inner">
        <noscript> The space booking requires JavaScript to be enabled. </noscript>
      </div>
    </div>
  </zone-wrapper>
</template>

<script setup>
import { computed } from 'vue';
import { isServer } from '@sitecore-jss/sitecore-jss/utils';
import ZoneWrapper from '../ZoneWrapper/ZoneWrapper.vue';
import { routeChangeStatus } from '../../../router';
import { useJssStore } from '../../../stores/jssStore';

const props = defineProps({
  fields: {
    type: Object,
    default: () => ({}),
  },
  rendering: {
    type: Object,
  },
  params: {
    type: Object,
    default: () => ({}),
  },
});

const jssStore = useJssStore();
const flds = props.fields || {};

const bookSpaceAPISettings = computed(() => {
  let previousPageUrl;
  let bookingEntryPage = '';
  if (isServer()) previousPageUrl = '';
  else if (routeChangeStatus.previousInternalRoute) {
    previousPageUrl = window.location.origin + routeChangeStatus.previousInternalRoute;
    bookingEntryPage = routeChangeStatus.previousInternalRoute;
  } else previousPageUrl = document.referrer || '';

  return {
    env: flds.env?.value,
    apiUrl: flds.scriptApiUrl?.value,
    bookingGTMId: flds.bookingGtmId?.value,
    bookingGTMAuth: flds.bookingGtmAuth?.value,
    bookingGTMEnv: flds.bookingGtmEnv?.value,
    softOpt: flds.bookingSoftOpt?.value,
    termsAndConditionsUrl: flds.termsAndConditionsUrl?.value?.href,
    phone: flds.phone?.value,
    areaBookings: true,
    areaEnquiries: !!flds.areaEnquiries?.value,
    pathUrl: flds.pathUrl?.value,
    venueId: jssStore.venueId?.toString().padStart(4, '0'),
    brand: jssStore.brandName,
    venueName: jssStore.venueName,
    venueImage: flds.venueImage?.value?.src ?? '',
    segment: jssStore.segment,
    worldpayHelper: isServer()
      ? ''
      : window?.location.protocol + '//' + window?.location.host + flds.worldpayPath?.value,
    enquiryFormOnly: false,
    spaceImages: {},
    division: jssStore.division || 'No division',
    isHotel: jssStore.isHotel || false,
    sports: jssStore.sports || false,
    previousPageUrl,
    bookingEntryPage,
  };
});
</script>

<style lang="scss">
@import './scss/BookSpaceWidget.scss';
</style>
